import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import * as yup from 'yup'
import Api from "../Api/Api"; 

function Resetpassword() {
    const navigate=useNavigate()

    const location=useLocation()
    const [mailId,setMailId]=useState()

    console.log("emaillllllll",mailId)

    const formik=useFormik({
        initialValues:{
            email:location.state.email || "",
            newPassword:"",
            confirmPassword:""
        },
        validationSchema: yup.object({
            newPassword: yup
            .string()
            .required("Password is required")
            .min(6, "Password should be at least 6 characters")
            .max(40, "Password should not exceed 40 characters"),
            confirmPassword: yup
            .string()
            .required("Confirm Password is required")
            .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
        }),
        onSubmit:async(values)=>{
            console.log("submit",values)
            try {
                const response = await Api.post("/user/reset-password",values)
                console.log("response---->Register",response.data)
                // localStorage.setItem("Quizetoken",response.data.result.token)
                // toast(response.data.message, {
                //     position: "top-right",
                //     autoClose: 2000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                // });
                navigate("/login",{state:{messagereset:response.data.message}})
            } catch (error) {
                console.log(error.response.data.message)
                toast(error.response.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
        })}}
    })

   useEffect(() => {
    // setMailId(location.state.email)
    if(location.state){
        toast(location.state.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
      }
      window.history.replaceState({}, document.title)
  }, [location.state])

  return (
    <>
    <ToastContainer />
    <div className="center">
        <div className="video-form container">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-12">
                    <div className="log-img">
                        <img src="/assets/images/login.png" />
                    </div>
                </div>
                <div className="col-lg-7 col-md-12">
                    <form onSubmit={formik.handleSubmit}>
                        {/* <!-- <a href="index.html"><i className="fa-solid fa-angle-left"></i></a> --> */}
                        <div className="form-header">
                            <h2>Reset password</h2>
                            <p>Enter a new password below to change your password.</p>
                        </div>
                
                        <label for="psw"><b>New Password</b></label>
                        <input type="password" placeholder="New Password" name="newPassword" value={formik.values.newPassword} onChange={formik.handleChange}   className="psw1" />
                         {formik.touched.newPassword && formik.errors.newPassword ? <div className='text-danger' style={{float: 'right',padding: '9px'}}>{formik.errors.password}</div> : null}
                        
                        <label for="psw"><b> Confirm Password</b></label>
                        <input type="password" placeholder="Confirm Password" name="confirmPassword" value={formik.values.confirmPassword} onChange={formik.handleChange}   className="psw2"  />
                        {formik.touched.confirmPassword && formik.errors.confirmPassword ? <div className='text-danger' style={{float: 'right',padding: '9px'}}>{formik.errors.confirmPassword}</div> : null}
                        
                   
                        <button type="submit" className="mt-5"><a>Continue</a> </button>
                       
                    </form>
                </div>
            </div>
            
         
        </div>
    </div>
    </>
  )
}

export default Resetpassword